import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Heading, Semibold } from "capitalrx-components-2.0/lib/typography";
import { FC } from "react";

export const UnifiedInformation: FC = () => {
  return (
    <Stack spacing="large">
      <Stack>
        <Heading>Pre-Certification</Heading>
        <Body>
          Call Judi Health at{" "}
          <a href="tel:1-833-599-1020">
            <Semibold>1-833-599-1020</Semibold>
          </a>
        </Body>
        <Body>
          Possession of this card or obtaining pre-certification does not guarantee coverage or payment for the service or procedure
          reviewed. Benefits are not insured by Cigna Healthcare or affiliates.
        </Body>
        <Body>See plan description for details. Penalty may apply for failure to pre-certify according to requirements.</Body>
      </Stack>

      <Stack>
        <Heading>Member Claims</Heading>
        <Body>
          <Stack spacing="none">
            <p>
              <Semibold>Cigna Medical Claims</Semibold>
            </p>
            <p>PO Box 188061</p>
            <p>Chattanooga, TN 37422 - 8061</p>
          </Stack>
        </Body>
        <Body>
          <Stack spacing="none">
            <p>
              <Semibold>Electronic Payer ID #:</Semibold> 62308
            </p>
            <p>
              To find a Cigna Healthcare provider, please visit <a href="https://www.myCigna.com">www.myCigna.com</a>
            </p>
          </Stack>
        </Body>
        <Body>*Benefits are not insured by Cigna Healthcare or affiliates</Body>

        <Shelf>
          <Body
            style={{
              color: "white",
              backgroundColor: "black",
              padding: "4px 8px 4px 8px",
            }}
          >
            <Semibold>Away from Home Care</Semibold>
          </Body>
          <Shelf.Spacer />
        </Shelf>
      </Stack>

      <Stack>
        <Heading>Rx Claims</Heading>
        <Body>
          <Stack spacing="none">
            <Semibold>Capital Rx</Semibold>
            <p>Attn: Claims</p>
            <p>9450 SW Gemini Dr. #87234</p>
            <p>Beaverton, Oregon 97008-7105</p>
          </Stack>
        </Body>

        <Body>
          <Stack spacing="none">
            <Semibold>Member Pharmacy Help Line:</Semibold>
            <a href="tel:1-833-599-1020">1-833-599-1020</a>
          </Stack>
        </Body>
      </Stack>
    </Stack>
  );
};
